/**
 * NOTE(mark): This is copied from the crew app with minimal changes.
 */

// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {Notification} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {Json} from '@supermove/utils';

// App
import DocumentAdditionalInfoGridFields from 'modules/Customer/Document/components/DocumentAdditionalInfoGridFields';
import DocumentAdditionalInfoListActions from 'modules/Customer/Document/components/DocumentAdditionalInfoListActions';
import DocumentAdditionalInfoListInput from 'modules/Customer/Document/components/DocumentAdditionalInfoListInput';
import DocumentAdditionalInfoListV2Input from 'modules/Customer/Document/components/DocumentAdditionalInfoListV2Input';
import DocumentAdditionalInfoRadioButtonInput from 'modules/Customer/Document/components/DocumentAdditionalInfoRadioButtonInput';
import DocumentAdditionalInfoRadioButtonsWithTextInputsFields from 'modules/Customer/Document/components/DocumentAdditionalInfoRadioButtonsWithTextInputsFields';
import DocumentAdditionalInfoSectionTextAreaInput from 'modules/Customer/Document/components/DocumentAdditionalInfoSectionTextAreaInput';
import DocumentAdditionalInfoSelectMultipleInput from 'modules/Customer/Document/components/DocumentAdditionalInfoSelectMultipleInput';

const getValue = ({form, documentAdditionalInfo, defaultValue}: any) => {
  return _.get(form, `values.additionalInfo.${documentAdditionalInfo.name}`, defaultValue);
};

const DocumentAdditionalInfoListFields = ({documentAdditionalInfo, form}: any) => {
  const items = getValue({form, documentAdditionalInfo, defaultValue: []});

  return (
    <React.Fragment>
      {items.map((item: any, index: any) => (
        <DocumentAdditionalInfoListInput
          key={index}
          isFirst={index === 0}
          isLast={index === items.length - 1}
          name={`additionalInfo.${documentAdditionalInfo.name}.${index}`}
          index={index}
          values={form.values}
          setFieldValue={form.setFieldValue}
          setFieldTouched={form.setFieldTouched}
        />
      ))}
      {/* @ts-expect-error TS(2741): Property 'color' is missing in type '{ text: strin... Remove this comment to see the full error message */}
      {items.length === 0 && <Notification.Warning text={'No Items'} />}
      <DocumentAdditionalInfoListActions
        name={`additionalInfo.${documentAdditionalInfo.name}`}
        form={form}
      />
    </React.Fragment>
  );
};

const DocumentAdditionalInfoListV2Fields = ({documentAdditionalInfo, form}: any) => {
  const items = getValue({form, documentAdditionalInfo, defaultValue: []});
  const metadata = Json.toObject(documentAdditionalInfo.metadata);
  const combinedItems = _.zip(items, _.get(metadata, 'fields'));

  return (
    <React.Fragment>
      {combinedItems.map((combinedItem, index) => {
        const [item, field] = combinedItem;
        return (
          <DocumentAdditionalInfoListV2Input
            key={index}
            isFirst={index === 0}
            item={item}
            field={field}
            isLast={index === items.length - 1}
            name={`additionalInfo.${documentAdditionalInfo.name}.${index}`}
            values={form.values}
            setFieldValue={form.setFieldValue}
            setFieldTouched={form.setFieldTouched}
          />
        );
      })}
      {/* @ts-expect-error TS(2741): Property 'color' is missing in type '{ text: strin... Remove this comment to see the full error message */}
      {items.length === 0 && <Notification.Warning text={'No Items'} />}
    </React.Fragment>
  );
};

const DocumentAdditionalInfoRadioButtonsFields = ({documentAdditionalInfo, form}: any) => {
  const values = Json.toObject(documentAdditionalInfo.values);

  return (
    <React.Fragment>
      {(values as any).map((value: any, index: any) => (
        <DocumentAdditionalInfoRadioButtonInput
          key={index}
          isFirst={index === 0}
          isLast={index === (values as any).length - 1}
          name={`additionalInfo.${documentAdditionalInfo.name}`}
          index={index}
          value={value}
          values={form.values}
          setFieldValue={form.setFieldValue}
          setFieldTouched={form.setFieldTouched}
        />
      ))}
    </React.Fragment>
  );
};

const DocumentAdditionalInfoSectionTextAreasFields = ({documentAdditionalInfo, form}: any) => {
  const items = getValue({form, documentAdditionalInfo, defaultValue: []});

  return (
    <React.Fragment>
      {items.map((item: any, index: any) => (
        <DocumentAdditionalInfoSectionTextAreaInput
          key={index}
          isFirst={index === 0}
          isLast={index === items.length - 1}
          name={`additionalInfo.${documentAdditionalInfo.name}.${index}`}
          index={index}
          values={form.values}
          setFieldValue={form.setFieldValue}
          setFieldTouched={form.setFieldTouched}
        />
      ))}
      {/* @ts-expect-error TS(2741): Property 'color' is missing in type '{ text: strin... Remove this comment to see the full error message */}
      {items.length === 0 && <Notification.Warning text={'No Items'} />}
    </React.Fragment>
  );
};

const DocumentAdditionalInfoSelectMultipleFields = ({documentAdditionalInfo, form}: any) => {
  const values = Json.toObject(documentAdditionalInfo.values);

  return (
    <React.Fragment>
      {(values as any).map((value: any, index: any) => (
        <DocumentAdditionalInfoSelectMultipleInput
          key={index}
          isFirst={index === 0}
          isLast={index === (values as any).length - 1}
          name={`additionalInfo.${documentAdditionalInfo.name}`}
          index={index}
          value={value}
          values={form.values}
          setFieldValue={form.setFieldValue}
          setFieldTouched={form.setFieldTouched}
        />
      ))}
    </React.Fragment>
  );
};

const DocumentAdditionalInfoFields = ({documentAdditionalInfo, form}: any) => {
  switch (documentAdditionalInfo.kind) {
    case 'GRID':
      return (
        <DocumentAdditionalInfoGridFields
          documentAdditionalInfo={documentAdditionalInfo}
          form={form}
        />
      );
    case 'LIST':
      return (
        <DocumentAdditionalInfoListFields
          documentAdditionalInfo={documentAdditionalInfo}
          form={form}
        />
      );
    case 'LIST_V2':
      return (
        <DocumentAdditionalInfoListV2Fields
          documentAdditionalInfo={documentAdditionalInfo}
          form={form}
        />
      );
    case 'RADIO_BUTTONS':
      return (
        <DocumentAdditionalInfoRadioButtonsFields
          documentAdditionalInfo={documentAdditionalInfo}
          form={form}
        />
      );
    case 'RADIO_BUTTONS_WITH_TEXT_INPUTS':
      return (
        <DocumentAdditionalInfoRadioButtonsWithTextInputsFields
          documentAdditionalInfo={documentAdditionalInfo}
          form={form}
        />
      );
    case 'SECTION_TEXT_AREAS':
      return (
        <DocumentAdditionalInfoSectionTextAreasFields
          documentAdditionalInfo={documentAdditionalInfo}
          form={form}
        />
      );
    case 'SELECT_MULTIPLE':
      return (
        <DocumentAdditionalInfoSelectMultipleFields
          documentAdditionalInfo={documentAdditionalInfo}
          form={form}
        />
      );
    default:
      return null;
  }
};

// --------------------------------------------------
// Data
// --------------------------------------------------
DocumentAdditionalInfoFields.fragment = gql`
  ${DocumentAdditionalInfoGridFields.fragment}
  ${DocumentAdditionalInfoRadioButtonsWithTextInputsFields.fragment}

  fragment DocumentAdditionalInfoFields_Document on Document {
    id
  }

  fragment DocumentAdditionalInfoFields on DocumentAdditionalInfo {
    name
    kind
    values
    ...DocumentAdditionalInfoGridFields
    ...DocumentAdditionalInfoRadioButtonsWithTextInputsFields
  }
`;

export default DocumentAdditionalInfoFields;
